import React, { Fragment, useEffect, useState } from "react";
import { useNavigate, useLocation } from 'react-router-dom';
import CommonAuthComponent from './CommonAuthComponent';

const ForgotUserId = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // Extract and store userId securely, then clean URL
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const userId = params.get('userId');
    
    if (userId) {
      // Store userId in sessionStorage for security (cleared when browser closes)
      sessionStorage.setItem('recoveredUserId', userId);
      
      // Clean the URL by removing the userId parameter
      const cleanUrl = new URL(window.location);
      cleanUrl.searchParams.delete('userId');
      
      // Replace current URL without userId parameter
      window.history.replaceState({}, '', cleanUrl.pathname + cleanUrl.search);
    }
  }, [location.search]);

  const handleOkayClick = () => {
    // Get the stored userId before clearing it
    const storedUserId = sessionStorage.getItem('recoveredUserId');
    
    // Clear the stored userId from sessionStorage since we're navigating away
    sessionStorage.removeItem('recoveredUserId');
    
    // Navigate to login with userId if available
    if (storedUserId) {
      navigate(`/login?userId=${encodeURIComponent(storedUserId)}`);
    } else {
      navigate('/login');
    }
  };

  return (
    <CommonAuthComponent>
      {/* Heading */}
      <h1 className="text-[22px] text-center mb-4 font-medium leading-[30px] text-teal-300">User ID</h1>

      {/* Description Text */}
      <div className="text-center mb-6">
        <p className="text-[16px] font-normal leading-[22px] text-teal-300 mb-1">Your User ID has been recovered.</p>
        <p className="text-[16px] font-normal leading-[22px] text-teal-300 mb-1">For security, please return to the</p>
        <p className="text-[16px] font-normal leading-[22px] text-teal-300 mb-[26px]">login page to continue.</p>
      </div>

      {/* Security Notice */}
      <p className="text-center text-[14px] text-teal-300 mb-5">For security, password reset link expires after 15 minutes</p>

      {/* Okay Button */}
      <div className="text-center">
        <button
          type="button"
          onClick={handleOkayClick}
          className={`w-full inline-flex disabled:opacity-50 rounded-[4px] border transition-all duration-300 text-body-md items-center font-semibold justify-center px-6 py-3.5 bg-REELTeal border border-transparent hover:bg-teal-200 text-white`}   
        >
          Okay
        </button>
      </div>
    </CommonAuthComponent>
  );
};

export default ForgotUserId;